{
  "name": "Score Multiplier Button",
  "powerupName": "ScoreMultiplier",
  "levelUpDescriptions": [
    "ScoreMultiplierUpgradeDescription1",
    "ScoreMultiplierUpgradeDescription2",
    "ScoreMultiplierUpgradeDescription3",
    "ScoreMultiplierUpgradeDescription4",
    "ScoreMultiplierUpgradeDescription5"
  ]
}